import { useQuery } from "@tanstack/react-query";

import { TeamMembersPanel } from "@/components/ui/admin/team/TeamMembersPanel";
import { createTeamService } from "@/core/services/factory";
import { useTranslations } from "@/lib/useTranslations";

export function TeamPage() {
  const t = useTranslations("team");

  const { data: members = [], isLoading } = useQuery({
    queryKey: ["team-members"],
    queryFn: () => createTeamService().listAll(),
  });

  if (isLoading) {
    return (
      <div className="mx-auto flex w-full max-w-6xl flex-1 items-center justify-center px-6 py-10 text-sm text-neutral-500">
        Chargement…
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-6 overflow-y-auto px-6 py-10">
      <header className="space-y-1">
        <p className="text-sm font-medium uppercase tracking-widest text-neutral-500">
          {t("eyebrow")}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-whart-text">
          {t("title")}
        </h1>
      </header>

      <TeamMembersPanel members={members} />
    </div>
  );
}
